import { __awaiter, __generator } from "tslib";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loadTripCategories } from "../../hooks/useTripCategories";
var initialState = {
    items: [],
    loading: false,
    error: null,
};
export var fetchTripCategories = createAsyncThunk("categories/fetchTripCategories", function (_1, _a) { return __awaiter(void 0, [_1, _a], void 0, function (_, _b) {
    var categories, error_1;
    var rejectWithValue = _b.rejectWithValue;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, , 3]);
                return [4 /*yield*/, loadTripCategories()];
            case 1:
                categories = _c.sent();
                return [2 /*return*/, categories];
            case 2:
                error_1 = _c.sent();
                return [2 /*return*/, rejectWithValue(error_1 instanceof Error ? error_1.message : "Failed to load categories")];
            case 3: return [2 /*return*/];
        }
    });
}); });
var categoriesSlice = createSlice({
    name: "categories",
    initialState: initialState,
    reducers: {},
    extraReducers: function (builder) {
        builder
            .addCase(fetchTripCategories.pending, function (state) {
            state.loading = true;
            state.error = null;
        })
            .addCase(fetchTripCategories.fulfilled, function (state, action) {
            state.loading = false;
            state.items = action.payload;
        })
            .addCase(fetchTripCategories.rejected, function (state, action) {
            state.loading = false;
            state.error = action.payload;
        });
    },
});
export var categoriesReducer = categoriesSlice.reducer;
